export enum UserRoleEnum {
    CommunityStakeholder = 86,
    IndividualStoryteller = 87,
    AdminAllowImpersonation = 88,
    DonorUser = 89,
    SuperAdmin = 137,
    SalesAdmin = 138,
}

export enum UserAccessEnum
{
    Active = 131,
    Inactive = 132,
}